/**
 * Interactive Elements - Handles creation and interaction of interactive points and transition marks
 */
document.addEventListener('DOMContentLoaded', function() {
  // Track if we're in Shopify's editor
  const isShopifyEditor = window.Shopify && window.Shopify.designMode;
  
  // Add coordinate grid for editor
  if (isShopifyEditor) {
    addCoordinateGrid();
  }
  
  // Initialize after a short delay to ensure main panorama code has run
  setTimeout(initInteractiveElements, 100);
  
  /**
   * Adds a coordinate grid overlay to help with positioning in editor
   */
  function addCoordinateGrid() {
    // Create the grid container
    const grid = document.createElement('div');
    grid.className = 'editor-coordinate-grid';
    grid.style.position = 'absolute';
    grid.style.top = '0';
    grid.style.left = '0';
    grid.style.width = '100%';
    grid.style.height = '100%';
    grid.style.pointerEvents = 'none';
    grid.style.zIndex = '5';
    
    // Create grid lines - 10% increments
    let gridHTML = '';
    
    // Vertical lines (for X coordinates)
    for (let i = 0; i <= 100; i += 10) {
      gridHTML += `
        <div style="position: absolute; top: 0; left: ${i}%; height: 100%; border-left: 1px dashed rgba(255,255,255,0.2); z-index: 5;">
          <div style="position: absolute; top: 5px; background: rgba(0,0,0,0.5); color: white; font-size: 10px; padding: 2px 4px; transform: translateX(-50%);">
            ${i}%
          </div>
        </div>
      `;
    }
    
    // Horizontal lines (for Y coordinates)
    for (let i = 0; i <= 100; i += 10) {
      gridHTML += `
        <div style="position: absolute; left: 0; top: ${i}%; width: 100%; border-top: 1px dashed rgba(255,255,255,0.2); z-index: 5;">
          <div style="position: absolute; left: 5px; background: rgba(0,0,0,0.5); color: white; font-size: 10px; padding: 2px 4px; transform: translateY(-50%);">
            ${i}%
          </div>
        </div>
      `;
    }
    
    grid.innerHTML = gridHTML;
    
    // Add coordinate tracking display
    const coordDisplay = document.createElement('div');
    coordDisplay.className = 'editor-coord-tracker';
    coordDisplay.style.position = 'fixed';
    coordDisplay.style.bottom = '10px';
    coordDisplay.style.left = '10px';
    coordDisplay.style.backgroundColor = 'rgba(0,0,0,0.7)';
    coordDisplay.style.color = 'white';
    coordDisplay.style.padding = '5px 10px';
    coordDisplay.style.borderRadius = '4px';
    coordDisplay.style.fontSize = '12px';
    coordDisplay.style.fontFamily = 'monospace';
    coordDisplay.style.zIndex = '1000';
    coordDisplay.textContent = 'Position: X: 0%, Y: 0%';
    document.body.appendChild(coordDisplay);
    
    // Add the grid after the editor loads
    setTimeout(() => {
      const panoramicContainer = document.querySelector('.panoramic-container');
      if (panoramicContainer) {
        panoramicContainer.appendChild(grid);
        
        // Update coordinate display on mouse move
        panoramicContainer.addEventListener('mousemove', function(e) {
          const rect = panoramicContainer.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          
          coordDisplay.textContent = `Position: X: ${x.toFixed(1)}%, Y: ${y.toFixed(1)}%`;
        });
        
        // Add click to copy coordinates
        panoramicContainer.addEventListener('click', function(e) {
          if (e.altKey) {
            const rect = panoramicContainer.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;
            
            // Format the coordinates
            const coordText = `X: ${x.toFixed(1)}%, Y: ${y.toFixed(1)}%`;
            
            // Flash the display to indicate copy
            const originalBg = coordDisplay.style.backgroundColor;
            coordDisplay.style.backgroundColor = 'rgba(0,150,0,0.8)';
            coordDisplay.textContent = `Copied: ${coordText}`;
            
            // Reset after flash
            setTimeout(() => {
              coordDisplay.style.backgroundColor = originalBg;
              coordDisplay.textContent = `Position: ${coordText}`;
            }, 1000);
            
            // Copy to clipboard
            navigator.clipboard.writeText(`${x.toFixed(1)}, ${y.toFixed(1)}`).catch(err => {
              console.error('Failed to copy coordinates', err);
            });
          }
        });
      }
    }, 500);
    
    
  }
  
  function initInteractiveElements() {
    // In editor mode, immediately fix the container and background
    if (isShopifyEditor) {
      fixEditorContainer();
    }
    
    // Initialize elements from data attributes
    createInteractiveElements();
    
    // If not in Shopify editor, fix right edge boundary in normal mode
    if (!isShopifyEditor) {
      fixRightBoundaryScrolling();
    }
  }

  /**
   * Fixes container dimensions and background in editor to match live site
   */
  function fixEditorContainer() {
    // Get key elements
    const panoramicWrapper = document.querySelector('.panoramic-wrapper');
    const panoramicContainer = document.querySelector('.panoramic-container');
    const bgElement = document.querySelector('.panoramic-background');
    
    if (!panoramicWrapper || !panoramicContainer || !bgElement) return;
    
    // Force consistent aspect ratio and size
    const editorFixStyles = document.createElement('style');
    editorFixStyles.textContent = `
      /* Force container size and aspect ratio */
      .panoramic-container {
        width: 100% !important;
        height: auto !important;
        aspect-ratio: 16/9 !important;
        overflow: hidden !important;
      }
      
      /* Center background and prevent scrolling */
      .panoramic-background {
        background-position: center center !important;
        background-size: cover !important;
        width: 100% !important;
        height: 100% !important;
        min-width: 100% !important;
        left: 0 !important;
      }
      
      /* Prevent wrapper from transforming */
      .panoramic-wrapper {
        transform: none !important;
        width: 100% !important;
        min-width: 100% !important;
        left: 0 !important;
        overflow: hidden !important;
      }
      
      /* Fix interactive points positioning */
      .interactive-point, .transition-mark {
        position: absolute !important;
        transform: translate(-50%, -50%) !important;
      }
      
      /* Make editor elements stand out */
      .shopify-editable {
        outline: 1px dashed rgba(92, 106, 196, 0.5);
        z-index: 5;
      }
      
      .shopify-editable:hover {
        outline: 2px dashed rgba(92, 106, 196, 0.8);
      }
      
      .shopify-selected {
        outline: 2px solid #5c6ac4 !important;
        z-index: 10 !important;
      }
    `;
    
    document.head.appendChild(editorFixStyles);
    
    // Directly apply critical styles
    panoramicWrapper.style.transform = 'none';
    panoramicWrapper.style.width = '100%';
    panoramicWrapper.style.overflow = 'hidden';
    
    bgElement.style.backgroundPosition = 'center center';
    bgElement.style.backgroundSize = 'cover';
    bgElement.style.width = '100%';
    
    panoramicContainer.style.width = '100%';
    panoramicContainer.style.height = 'auto';
    panoramicContainer.style.aspectRatio = '16/9';
    panoramicContainer.style.overflow = 'hidden';
    
    console.log('Editor container fixed for accurate positioning');
  }

  /**
   * Prevents users from scrolling past the right edge of the image
   */
  function fixRightBoundaryScrolling() {
    if (!window.interactiveSpace) return;
    
    const { elements } = window.interactiveSpace;
    const { panoramicWrapper, panoramicContainer, bgElement } = elements;
    
    if (!panoramicWrapper || !panoramicContainer || !bgElement) return;
    
    // Get the actual image width to set proper boundaries
    const style = getComputedStyle(bgElement);
    const bgImage = style.backgroundImage.replace(/url\(['"]?(.*?)['"]?\)/i, '$1');
    
    if (bgImage) {
      const img = new Image();
      img.onload = function() {
        const imgWidth = this.width;
        const imgHeight = this.height;
        const containerWidth = panoramicContainer.offsetWidth;
        const containerHeight = panoramicContainer.offsetHeight;
        
        // Calculate how wide the background should be when displayed at full height
        const bgWidth = (imgWidth / imgHeight) * containerHeight;
        
        // Set max scroll distance to prevent scrolling past the right edge
        // This makes sure the background always fills the right side
        const maxScroll = Math.max(0, bgWidth - containerWidth);
        
        // Store this value for the main JS to use
        bgElement.dataset.maxScrollPixels = maxScroll;
        bgElement.dataset.originalMaxScrollPixels = maxScroll;
      };
      img.src = bgImage;
    }
  }
  
  /**
   * Creates interactive points and transition marks from data attributes
   */
  function createInteractiveElements() {
    const ipReferences = document.querySelectorAll('.ip-reference');
    const panoramicWrapper = document.querySelector('.panoramic-wrapper');
    
    if (!panoramicWrapper || ipReferences.length === 0) return;
    
    // Force consistent container in editor
    if (isShopifyEditor) {
      fixEditorContainer();
    }
    
    // Remove existing points first to prevent duplicates
    const existingPoints = panoramicWrapper.querySelectorAll('.interactive-point, .transition-mark');
    existingPoints.forEach(point => {
      // Only remove points that aren't part of the editor selection
      if (!point.classList.contains('shopify-selected')) {
        point.remove();
      }
    });
    
    ipReferences.forEach(reference => {
      const type = reference.dataset.type;
      
      if (type === 'interactive_point') {
        createInteractivePoint(reference, panoramicWrapper);
      } else if (type === 'transition_mark') {
        createTransitionMark(reference, panoramicWrapper);
      }
    });
    
    // After creating elements, ensure dialog boxes work properly
    enhanceDialogBoxes();
  }

  /**
   * Creates an interactive point element with dialog box
   */
  function createInteractivePoint(reference, parent) {
    // For editor mode - enforce container size first
    if (isShopifyEditor) {
      fixEditorContainer();
    }
    
    const x = reference.dataset.x;
    const y = reference.dataset.y;
    const title = reference.dataset.title;
    const link = reference.dataset.link;
    const pointColor = reference.dataset.pointColor;
    const dialogColor = reference.dataset.dialogColor;
    const textColor = reference.dataset.textColor;
    const pulseColor = reference.dataset.pulseColor;
    
    // Skip if we don't have coordinates
    if (!x || !y) return;
    
    // Create interactive point element
    const pointElement = document.createElement('div');
    pointElement.className = 'interactive-point';
    pointElement.style.left = x + '%';
    pointElement.style.top = y + '%';
    
    // Store original coordinates for reference
    pointElement.dataset.originalX = x;
    pointElement.dataset.originalY = y;
    
    // Create point indicator
    const indicator = document.createElement('div');
    indicator.className = 'point-indicator';
    indicator.style.backgroundColor = pointColor;
    
    // Create pulse ring
    const ring = document.createElement('div');
    ring.className = 'ring-pulse';
    ring.style.borderColor = pulseColor;
    
    // Create dialog box
    const dialog = document.createElement('div');
    dialog.className = 'dialog-box';
    dialog.style.backgroundColor = dialogColor;
    
    // Create title and link
    const linkElement = document.createElement('a');
    linkElement.href = link || '#';
    linkElement.className = 'dialog-link';
    linkElement.style.color = textColor;
    
    const titleElement = document.createElement('h3');
    titleElement.style.color = textColor;
    titleElement.textContent = title;
    
    // Assemble the elements
    indicator.appendChild(ring);
    linkElement.appendChild(titleElement);
    dialog.appendChild(linkElement);
    pointElement.appendChild(indicator);
    pointElement.appendChild(dialog);
    
    // Store original reference block ID for Shopify editor
    if (isShopifyEditor) {
      const blockId = reference.getAttribute('data-block-id');
      if (blockId) {
        pointElement.dataset.shopifyId = blockId;
        
        // Add class to show this is an editable element
        pointElement.classList.add('shopify-editable');
        
        // Add coordinate badge with exact position
        const coordBadge = document.createElement('div');
        coordBadge.className = 'editor-badge';
        coordBadge.textContent = `${x}%, ${y}%`;
        coordBadge.style.position = 'absolute';
        coordBadge.style.top = '-20px';
        coordBadge.style.left = '50%';
        coordBadge.style.transform = 'translateX(-50%)';
        coordBadge.style.backgroundColor = '#5c6ac4';
        coordBadge.style.color = 'white';
        coordBadge.style.padding = '2px 6px';
        coordBadge.style.borderRadius = '4px';
        coordBadge.style.fontSize = '10px';
        coordBadge.style.pointerEvents = 'none';
        coordBadge.style.whiteSpace = 'nowrap';
        coordBadge.style.zIndex = '100';
        pointElement.appendChild(coordBadge);
        
        // Add drag handle for repositioning
        addDragHandle(pointElement, reference);
      }
    }
    
    // Add the interactive point to the panoramic wrapper
    parent.appendChild(pointElement);
    
    // In editor mode, keep reference hidden but available
    if (isShopifyEditor) {
      // Move reference off-screen but keep it in DOM
      reference.style.position = 'absolute';
      reference.style.left = '-9999px';
      reference.style.height = '1px';
      reference.style.overflow = 'hidden';
    } else {
      // In normal mode, remove reference elements
      reference.remove();
    }
  }

 
/**
 * Apply blur effects to transition elements - CORRECTED VERSION
 */
function applyBlurEffects(element, data) {
  // First, remove all existing blur-related classes
  element.classList.remove('blur-effect');
  element.classList.remove('blur-ice');
  element.classList.remove('blur-black_ice');
  element.classList.remove('blur-none');
  
  // Check if blur is enabled
  if (data.enableBlur === 'true') {
    const blurType = data.blurType;
    const blurIntensity = `${data.blurIntensity}px`;
    
    // Add blur-effect class for ALL blur types
    element.classList.add('blur-effect');
    
    // Handle different blur types
    if (blurType === 'none') {
      // For "none" type - APPLY BLUR BUT WITH NO TINT
      element.style.backdropFilter = `blur(${blurIntensity})`;
      element.style.webkitBackdropFilter = `blur(${blurIntensity})`;
      element.style.backgroundColor = 'transparent';
      
      // Add class for tracking
      element.classList.add('blur-none');
      
      // Set CSS variables for consistent styling
      element.style.setProperty('--blur-filter', `blur(${blurIntensity})`);
      element.style.setProperty('--blur-bg-color', 'transparent');
    } 
    else if (blurType === 'ice') {
      // Apply Ice blur effect (white tint)
      element.style.backdropFilter = `blur(${blurIntensity})`;
      element.style.webkitBackdropFilter = `blur(${blurIntensity})`;
      element.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
      
      // Add class for styling
      element.classList.add('blur-ice');
      
      // Set CSS variables for consistent styling
      element.style.setProperty('--blur-filter', `blur(${blurIntensity})`);
      element.style.setProperty('--blur-bg-color', 'rgba(255, 255, 255, 0.5)');
    } 
    else if (blurType === 'black_ice') {
      // Apply Black Ice blur effect (black tint)
      element.style.backdropFilter = `blur(${blurIntensity})`;
      element.style.webkitBackdropFilter = `blur(${blurIntensity})`;
      element.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
      
      // Add class for styling
      element.classList.add('blur-black_ice');
      
      // Set CSS variables for consistent styling
      element.style.setProperty('--blur-filter', `blur(${blurIntensity})`);
      element.style.setProperty('--blur-bg-color', 'rgba(0, 0, 0, 0.5)');
    }
  } else {
    // Blur is not enabled, remove all blur-related styles
    element.style.backdropFilter = 'none';
    element.style.webkitBackdropFilter = 'none';
    element.style.backgroundColor = 'transparent';
    element.style.removeProperty('--blur-filter');
    element.style.removeProperty('--blur-bg-color');
  }
}

  /**
   * Creates a transition mark element
   */

  // STARTT 

 /**
 * Creates a transition mark element with improved mobile usability
 */
function createTransitionMark(reference, parent) {
  // For editor mode - enforce container size first
  if (isShopifyEditor) {
    fixEditorContainer();
  }
  
  const x = reference.dataset.x;
  const y = reference.dataset.y;
  const direction = reference.dataset.direction;
  const title = reference.dataset.title;
  const link = reference.dataset.link;
  const width = reference.dataset.width;
  const bgColor = reference.dataset.bgColor;
  const textColor = reference.dataset.textColor;
  const arrowColor = reference.dataset.arrowColor;
  const borderColor = reference.dataset.borderColor;
  const transparentBg = reference.dataset.transparentBg === 'true';
  const transparentBorder = reference.dataset.transparentBorder === 'true';
  
  // Add these new blur-related attributes
  const enableBlur = reference.dataset.enableBlur;
  const blurType = reference.dataset.blurType;
  const blurIntensity = reference.dataset.blurIntensity;
  
  // Skip if we don't have coordinates
  if (!x || !y) return;
  
  // Create transition mark element
  const transitionElement = document.createElement('div');
  transitionElement.className = 'transition-mark transition-' + direction;
  transitionElement.style.left = x + '%';
  transitionElement.style.top = y + '%';
  
  // Store original coordinates for reference
  transitionElement.dataset.originalX = x;
  transitionElement.dataset.originalY = y;
  
  // Create link
  const linkElement = document.createElement('a');
  linkElement.href = link || '#';
  linkElement.className = 'transition-link';
  
  // Create container with animated state
  const container = document.createElement('div');
  container.className = 'transition-container';
  
  // Handle background color - only if not using blur and not transparent
  if (!transparentBg && (!enableBlur || enableBlur !== 'true')) {
    container.style.backgroundColor = bgColor;
  }
  
  if (!transparentBorder) {
    container.style.border = '1px solid ' + borderColor;
  }
  
  // Store blur settings as data attributes on the container for easy access later
  if (enableBlur === 'true') {
    container.dataset.enableBlur = enableBlur;
    container.dataset.blurType = blurType;
    container.dataset.blurIntensity = blurIntensity;
  }
  
  // Apply blur effects to the container
  applyBlurEffects(container, { 
    enableBlur: enableBlur,
    blurType: blurType, 
    blurIntensity: blurIntensity 
  });
  
  // Create arrow and title elements
  const arrow = document.createElement('div');
  arrow.className = 'transition-arrow';
  arrow.style.color = arrowColor;
  arrow.textContent = direction === 'left' ? '←' : '→';
  
  // Create wrapper for title to facilitate animation
  const titleWrapper = document.createElement('div');
  titleWrapper.className = 'transition-title-wrapper';
  
  const titleElement = document.createElement('div');
  titleElement.className = 'transition-title';
  titleElement.style.color = textColor;
  titleElement.textContent = title;
  
  // Add title to wrapper
  titleWrapper.appendChild(titleElement);
  
  // Set width based on direction
  if (direction === 'left') {
    // For left transitions, set minimal initial width with just the arrow
    transitionElement.style.width = 'auto';
    container.style.justifyContent = 'flex-start';
    container.style.minWidth = '40px'; // Just enough for the arrow
    
    // Start with hidden title
    titleWrapper.style.opacity = '0';
    titleWrapper.style.maxWidth = '0';
    titleWrapper.style.overflow = 'hidden';
    
    // Assemble in correct order
    container.appendChild(arrow);
    container.appendChild(titleWrapper);
    
  } else { // right direction
    // For right transitions, set minimal initial width with just the arrow
    transitionElement.style.width = 'auto';
    container.style.justifyContent = 'flex-end';
    container.style.minWidth = '40px'; // Just enough for the arrow
    
    // Start with hidden title
    titleWrapper.style.opacity = '0';
    titleWrapper.style.maxWidth = '0';
    titleWrapper.style.overflow = 'hidden';
    
    // Assemble in correct order
    container.appendChild(titleWrapper);
    container.appendChild(arrow);
  }
  
  linkElement.appendChild(container);
  transitionElement.appendChild(linkElement);
  
  // Define a function to preserve blur effects
  function preserveBlurEffects() {
    // Check if blur was enabled
    if (container.dataset.enableBlur === 'true') {
      // Re-apply the blur effect to ensure it stays visible
      applyBlurEffects(container, {
        enableBlur: container.dataset.enableBlur,
        blurType: container.dataset.blurType,
        blurIntensity: container.dataset.blurIntensity
      });
    }
  }
  
  // Detect if we're on a mobile device
  const isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  // Function to show text
  function showText() {
    if (direction === 'left') {
      // For left marks, expand to the right
      titleWrapper.style.transition = 'opacity 0.3s ease, max-width 0.3s ease';
      titleWrapper.style.maxWidth = `${width}px`;
      titleWrapper.style.opacity = '1';
      
      // Change minWidth but preserve other styles
      container.style.minWidth = '';
      
      // Make sure blur effect persists
      preserveBlurEffects();
    } else {
      // For right marks, expand to the left
      titleWrapper.style.transition = 'opacity 0.3s ease, max-width 0.3s ease';
      titleWrapper.style.maxWidth = `${width}px`;
      titleWrapper.style.opacity = '1';
      
      // Change minWidth but preserve other styles
      container.style.minWidth = '';
      
      // Make sure blur effect persists
      preserveBlurEffects();
    }
  }
  
  function hideText() {
    if (!isShopifyEditor) {
      titleWrapper.style.opacity = '0';
      titleWrapper.style.maxWidth = '0';
      
      // Make sure blur effect persists when closing
      preserveBlurEffects();
    }
  }
  
  // Don't add hover effects in editor mode
  if (!isShopifyEditor) {
    // Add mobile-specific class for styling
    if (isMobile) {
      transitionElement.classList.add('mobile-transition');
      
      // Store original link URL
      const originalUrl = linkElement.href;
      
      // Remove href to prevent immediate navigation on first tap
      linkElement.removeAttribute('href');
      
      // Mobile behavior - two-tap pattern
      let isExpanded = false;
      let navigationEnabled = false;
      
      // First tap expands and shows title
      transitionElement.addEventListener('touchstart', function(e) {
        e.stopPropagation();
        
        if (!isExpanded) {
          // First tap - show text
          showText();
          isExpanded = true;
          
          // Add timer to auto-collapse
          setTimeout(() => {
            if (isExpanded) {
              hideText();
              isExpanded = false;
              navigationEnabled = false;
            }
          }, 4000); // Collapse after 4 seconds of inactivity
          
          // Setup for second tap - enable navigation
          navigationEnabled = true;
          
          // Prevent default to avoid any navigation
          e.preventDefault();
        } else if (navigationEnabled) {
          // Second tap - navigate to link
          window.location.href = originalUrl;
        }
      });
      
      // Hide when tapping elsewhere
      document.addEventListener('touchstart', function(e) {
        if (isExpanded && !transitionElement.contains(e.target)) {
          hideText();
          isExpanded = false;
          navigationEnabled = false;
        }
      });
    } else {
      // Desktop behavior with hover
      transitionElement.addEventListener('mouseenter', showText);
      transitionElement.addEventListener('mouseleave', hideText);
    }
  } else {
    // In editor mode, always show title
    titleWrapper.style.opacity = '1';
    titleWrapper.style.maxWidth = `${width}px`;
    container.style.minWidth = '';
    
    // Make sure blur effect persists in editor mode
    preserveBlurEffects();
  }
  
  // Store original reference block ID for Shopify editor
  if (isShopifyEditor) {
    const blockId = reference.getAttribute('data-block-id');
    if (blockId) {
      transitionElement.dataset.shopifyId = blockId;
      
      // Add class to show this is an editable element
      transitionElement.classList.add('shopify-editable');
      
      // Add coordinate badge with exact position
      const coordBadge = document.createElement('div');
      coordBadge.className = 'editor-badge';
      coordBadge.textContent = `${x}%, ${y}%`;
      coordBadge.style.position = 'absolute';
      coordBadge.style.top = '-20px';
      coordBadge.style.left = '50%';
      coordBadge.style.transform = 'translateX(-50%)';
      coordBadge.style.backgroundColor = '#5c6ac4';
      coordBadge.style.color = 'white';
      coordBadge.style.padding = '2px 6px';
      coordBadge.style.borderRadius = '4px';
      coordBadge.style.fontSize = '10px';
      coordBadge.style.pointerEvents = 'none';
      coordBadge.style.whiteSpace = 'nowrap';
      coordBadge.style.zIndex = '100';
      transitionElement.appendChild(coordBadge);
      
      // Add drag handle for repositioning
      addDragHandle(transitionElement, reference);
    }
  }
  
  // Add the transition mark to the panoramic wrapper
  parent.appendChild(transitionElement);
  
  // In editor mode, keep reference hidden but available
  if (isShopifyEditor) {
    // Move reference off-screen but keep it in DOM
    reference.style.position = 'absolute';
    reference.style.left = '-9999px';
    reference.style.height = '1px';
    reference.style.overflow = 'hidden';
  } else {
    // In normal mode, remove reference elements
    reference.remove();
  }
}

/**
 * CSS styles for transitions with improved mobile support
 */
function addTransitionMarkStyles() {
  const styleElement = document.createElement('style');
  styleElement.id = 'transition-mark-styles';
  styleElement.textContent = `
    /* Base styles for transition marks */
    .transition-container {
      display: flex;
      align-items: center;
      transition: all 0.3s ease;
      white-space: nowrap;
      padding: 6px 12px;
      border-radius: 4px;
      box-sizing: border-box;
    }
    
    .transition-title-wrapper {
      transition: opacity 0.3s ease, max-width 0.3s ease;
      overflow: hidden;
    }
    
    .transition-title {
      padding: 0 8px;
      font-weight: 500;
      white-space: nowrap;
    }
    
    .transition-arrow {
      font-size: 18px;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 18px;
    }
    
    /* Left transition mark */
    .transition-left .transition-container {
      flex-direction: row;
    }
    
    /* Right transition mark */
    .transition-right .transition-container {
      flex-direction: row;
    }
    
    /* Mobile-specific styles */
    .mobile-transition {
      z-index: 10; /* Higher z-index for mobile elements */
    }
    
    .mobile-transition .transition-container {
      padding: 14px 16px; /* Larger touch target */
      min-height: 44px; /* Apple's recommended minimum touch target height */
    }
    
    .mobile-transition .transition-arrow {
      font-size: 24px; /* Larger arrow for better visibility */
      min-width: 24px;
      font-weight: bold;
    }
    
    /* Create a larger invisible touch target */
    .mobile-transition::before {
      content: '';
      position: absolute;
      top: -15px;
      left: -15px;
      right: -15px;
      bottom: -15px;
      z-index: -1;
    }
    
    /* Visual feedback for touch actions */
    .mobile-transition .transition-container:active {
      opacity: 0.7;
      transform: scale(0.95);
    }
    
    /* Legacy media query support for non-mobile-classified elements */
    @media (hover: none) {
      .transition-container:not(.mobile-transition .transition-container) {
        padding: 12px 14px;
      }
      
      .transition-arrow:not(.mobile-transition .transition-arrow) {
        font-size: 22px;
        min-width: 22px;
      }
    }
  `;
  
  // Remove existing styles if present to avoid duplicates
  const existingStyles = document.querySelector('#transition-mark-styles');
  if (existingStyles) {
    existingStyles.parentNode.removeChild(existingStyles);
  }
  
  document.head.appendChild(styleElement);
}

  // END

  
  // Call this function when the document loads to add the styles
  document.addEventListener('DOMContentLoaded', function() {
    addTransitionMarkStyles();
  });

  /**
   * Adds a drag handle for repositioning elements in editor mode
   */
  function addDragHandle(element, reference) {
    const dragHandle = document.createElement('div');
    dragHandle.className = 'editor-drag-handle';
    dragHandle.innerHTML = '✥'; // Cross-hair icon for more precise positioning
    dragHandle.style.position = 'absolute';
    dragHandle.style.top = '-40px';
    dragHandle.style.left = '50%';
    dragHandle.style.transform = 'translateX(-50%)';
    dragHandle.style.backgroundColor = '#5c6ac4';
    dragHandle.style.color = 'white';
    dragHandle.style.padding = '3px 8px';
    dragHandle.style.borderRadius = '4px';
    dragHandle.style.fontSize = '14px';
    dragHandle.style.cursor = 'move';
    dragHandle.style.zIndex = '200';
    dragHandle.title = 'Drag to reposition';
    
    // Set up drag functionality
    dragHandle.addEventListener('mousedown', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Fix container size before dragging
      fixEditorContainer();
      
      // Get container dimensions for percentage calculations
      const panoramicContainer = document.querySelector('.panoramic-container');
      const containerRect = panoramicContainer.getBoundingClientRect();
      
      // Starting positions
      const startX = e.clientX;
      const startY = e.clientY;
      const initialLeft = parseFloat(element.style.left);
      const initialTop = parseFloat(element.style.top);
      
      // Create coordinate display
      const coordDisplay = document.createElement('div');
      coordDisplay.className = 'editor-coord-display';
      coordDisplay.style.position = 'fixed';
      coordDisplay.style.top = '10px';
      coordDisplay.style.right = '10px';
      coordDisplay.style.backgroundColor = 'rgba(0,0,0,0.8)';
      coordDisplay.style.color = 'white';
      coordDisplay.style.padding = '8px 12px';
      coordDisplay.style.borderRadius = '4px';
      coordDisplay.style.zIndex = '9999';
      coordDisplay.style.fontFamily = 'monospace';
      coordDisplay.style.fontSize = '14px';
      coordDisplay.textContent = `X: ${initialLeft.toFixed(1)}%, Y: ${initialTop.toFixed(1)}%`;
      document.body.appendChild(coordDisplay);
      
      // Handle mouse movement
      function handleMouseMove(e) {
        // Calculate delta movement in pixels
        const deltaX = e.clientX - startX;
        const deltaY = e.clientY - startY;
        
        // Convert to percentage of container dimensions
        const deltaXPercent = (deltaX / containerRect.width) * 100;
        const deltaYPercent = (deltaY / containerRect.height) * 100;
        
        // Calculate new position
        let newLeft = initialLeft + deltaXPercent;
        let newTop = initialTop + deltaYPercent;
        
        // Clamp values to keep within bounds
        newLeft = Math.min(Math.max(0, newLeft), 100);
        newTop = Math.min(Math.max(0, newTop), 100);
        
        // Update element position
        element.style.left = newLeft + '%';
        element.style.top = newTop + '%';
        
        // Update coordinate display
        coordDisplay.textContent = `X: ${newLeft.toFixed(1)}%, Y: ${newTop.toFixed(1)}%`;
        
        // Update coordinate badge
        const badge = element.querySelector('.editor-badge');
        if (badge) {
          badge.textContent = `${newLeft.toFixed(1)}%, ${newTop.toFixed(1)}%`;
        }
        
        // Update the reference element's data attributes in real-time
        if (reference) {
          reference.dataset.x = newLeft.toString();
          reference.dataset.y = newTop.toString();
        }
      }
      
      // Handle mouse up - cleanup
      function handleMouseUp() {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        
        // Remove coordinate display
        if (coordDisplay.parentNode) {
          coordDisplay.parentNode.removeChild(coordDisplay);
        }
        
        // Final position values
        const finalLeft = parseFloat(element.style.left);
        const finalTop = parseFloat(element.style.top);
        
        // Update reference data attributes permanently
        if (reference) {
          reference.dataset.x = finalLeft.toString();
          reference.dataset.y = finalTop.toString();
          
          // Trigger editor update immediately to save the position
          triggerEditorUpdate(finalLeft, finalTop);
        }
      }
      
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    });
    
    element.appendChild(dragHandle);
  }

  /**
   * Ensures dialog box behavior works correctly
   */

  // START

  
 /**
 * Ensures dialog box behavior works correctly, maintaining hover functionality
 * even after interacting with the background
 */
function enhanceDialogBoxes() {
  const interactivePoints = document.querySelectorAll('.interactive-point');
  const panoramicContainer = document.querySelector('.panoramic-container');
  let activeDialog = null;
  
  if (!panoramicContainer) return;
  
  // Function to close all dialogs
  function closeAllDialogs() {
    interactivePoints.forEach(point => {
      const dialogBox = point.querySelector('.dialog-box');
      if (dialogBox) {
        dialogBox.style.opacity = '0';
        dialogBox.style.visibility = 'hidden';
        dialogBox.style.transform = 'translateX(-50%) translateY(10px)';
      }
    });
    activeDialog = null;
  }
  
  // Add touch/click event to the panoramic container to close dialogs when touching elsewhere
  panoramicContainer.addEventListener('touchstart', function(e) {
    // In editor mode, don't handle touch events
    if (isShopifyEditor) return;
    
    // Check if the touch is on an interactive point or dialog box
    const clickedPoint = e.target.closest('.interactive-point');
    
    // If clicked outside any point, close all dialogs
    if (!clickedPoint) {
      closeAllDialogs();
    }
  }, {passive: true});
  
  // Also handle mouse clicks for non-touch devices
  panoramicContainer.addEventListener('click', function(e) {
    // In editor mode, don't handle click events
    if (isShopifyEditor) return;
    
    // Check if the click is on an interactive point or dialog box
    const clickedPoint = e.target.closest('.interactive-point');
    
    // If clicked outside any point, close all dialogs
    if (!clickedPoint) {
      closeAllDialogs();
    }
  });
  
  // Handle the interactive points
  interactivePoints.forEach(point => {
    const dialogBox = point.querySelector('.dialog-box');
    const indicator = point.querySelector('.point-indicator');
    
    if (!dialogBox || !indicator) return;
    
    // Add specific CSS to ensure hover effects work consistently
    if (!isShopifyEditor) {
      // Add hover class for CSS targeting
      point.classList.add('hover-enabled');
      
      // Set up hover events for desktop
      point.addEventListener('mouseenter', function() {
        if (window.matchMedia('(hover: hover)').matches && !isShopifyEditor) {
          dialogBox.style.opacity = '1';
          dialogBox.style.visibility = 'visible';
          dialogBox.style.transform = 'translateX(-50%) translateY(0)';
          activeDialog = dialogBox;
        }
      });
      
      point.addEventListener('mouseleave', function() {
        if (window.matchMedia('(hover: hover)').matches && !isShopifyEditor) {
          dialogBox.style.opacity = '0';
          dialogBox.style.visibility = 'hidden';
          dialogBox.style.transform = 'translateX(-50%) translateY(10px)';
          activeDialog = null;
        }
      });
    }
    
    // For touch devices - only handle touch on the indicator, not the dialog
    indicator.addEventListener('touchstart', (e) => {
      // In editor mode, don't handle touch events
      if (isShopifyEditor) return;
      
      e.stopPropagation();
      
      // Close any other open dialog first
      if (activeDialog && activeDialog !== dialogBox) {
        activeDialog.style.opacity = '0';
        activeDialog.style.visibility = 'hidden';
        activeDialog.style.transform = 'translateX(-50%) translateY(10px)';
      }
      
      // Toggle dialog visibility
      if (dialogBox.style.visibility === 'visible') {
        dialogBox.style.opacity = '0';
        dialogBox.style.visibility = 'hidden';
        dialogBox.style.transform = 'translateX(-50%) translateY(10px)';
        activeDialog = null;
      } else {
        dialogBox.style.opacity = '1';
        dialogBox.style.visibility = 'visible';
        dialogBox.style.transform = 'translateX(-50%) translateY(0)';
        activeDialog = dialogBox;
      }
    });
    
    // Also handle mouse clicks for non-touch devices
    indicator.addEventListener('click', (e) => {
      // In editor mode, don't handle click events
      if (isShopifyEditor) return;
      
      e.stopPropagation();
      
      // On devices without hover capability, use click to toggle
      if (!window.matchMedia('(hover: hover)').matches) {
        // Close any other open dialog first
        if (activeDialog && activeDialog !== dialogBox) {
          activeDialog.style.opacity = '0';
          activeDialog.style.visibility = 'hidden';
          activeDialog.style.transform = 'translateX(-50%) translateY(10px)';
        }
        
        // Toggle dialog visibility
        if (dialogBox.style.visibility === 'visible') {
          dialogBox.style.opacity = '0';
          dialogBox.style.visibility = 'hidden';
          dialogBox.style.transform = 'translateX(-50%) translateY(10px)';
          activeDialog = null;
        } else {
          dialogBox.style.opacity = '1';
          dialogBox.style.visibility = 'visible';
          dialogBox.style.transform = 'translateX(-50%) translateY(0)';
          activeDialog = dialogBox;
        }
      }
    });
    
    // Prevent dialog clicks from closing the dialog
    dialogBox.addEventListener('touchstart', (e) => {
      e.stopPropagation();
    });
    
    dialogBox.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });
  
  // Add these styles to document to ensure consistent hover behavior
  const hoverStyles = document.createElement('style');
  hoverStyles.textContent = `
    /* Ensure dialog styles are consistently applied */
    .interactive-point .dialog-box {
      transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s;
      visibility: hidden;
      opacity: 0;
      transform: translateX(-50%) translateY(10px);
    }
    
    /* Apply hover effects for desktop devices */
    @media (hover: hover) {
      .interactive-point.hover-enabled:hover .dialog-box {
        opacity: 1;
        visibility: visible;
        transform: translateX(-50%) translateY(0);
      }
    }
  `;
  
  // Add the style to the document if it doesn't exist yet
  if (!document.querySelector('style#interactive-hover-styles')) {
    hoverStyles.id = 'interactive-hover-styles';
    document.head.appendChild(hoverStyles);
  }
}

  /**
   * Trigger an update to notify the editor of changes
   */
  function triggerEditorUpdate(x, y) {
    console.log(`Position updated: X: ${x.toFixed(1)}%, Y: ${y.toFixed(1)}%`);
    
    // Create a custom event to notify the editor
    const event = new CustomEvent('interactive:position:updated', {
      bubbles: true,
      cancelable: true,
      detail: { x, y, timestamp: Date.now() }
    });
    
    document.dispatchEvent(event);
    
    // Force refresh the editor UI
    if (typeof Shopify !== 'undefined' && 
        Shopify.designMode && 
        typeof Shopify.designMode.updateDesign === 'function') {
      try {
        Shopify.designMode.updateDesign();
      } catch (e) {
        console.log('Could not update editor design:', e);
      }
    }
  }

  // Special handling for Shopify editor if available
  if (isShopifyEditor) {
    // Apply editor styles immediately
    const editorStyles = document.createElement('style');
    editorStyles.textContent = `
      /* Make sure everything renders consistently */
      .editor-badge {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
      }
      
      /* Custom crosshair cursor for the editor */
      .panoramic-container {
        cursor: crosshair !important;
      }
      
      /* Animation for the drag handle */
      .editor-drag-handle {
        transition: transform 0.2s ease, background-color 0.2s ease;
      }
      
      .editor-drag-handle:hover {
        transform: translateX(-50%) scale(1.1);
        background-color: #7284e0;
      }
      
      /* Help button for editor */
      .editor-help-btn {
        position: fixed;
        bottom: 20px;
        right: 20px;
        background-color: #5c6ac4;
        color: white;
        padding: 8px 15px;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
        z-index: 9999;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
        box-shadow: 0 2px 4px rgba(0,0,0,0.2);
      }
      
      /* Editor mode header */
      .editor-mode-header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background-color: rgba(0,0,0,0.75);
        color: white;
        padding: 8px;
        text-align: center;
        font-size: 12px;
        z-index: 9999;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
      }
    `;
    document.head.appendChild(editorStyles);
    
    
    // Re-initialize when the editor makes changes
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('.interactive-space')) {
        fixEditorContainer();
        setTimeout(initInteractiveElements, 200);
      }
    });
    
    // Handle block selection
    document.addEventListener('shopify:block:select', function(event) {
      const blockId = event.detail.blockId;
      const element = document.querySelector(`[data-shopify-id="${blockId}"]`);
      
      if (element) {
        // Fix container first
        fixEditorContainer();
        
        // Highlight the selected element
        element.classList.add('shopify-selected');
        
        // Get exact coordinates
        const x = parseFloat(element.style.left);
        const y = parseFloat(element.style.top);
        
        // Update coordinate display
        const badge = element.querySelector('.editor-badge');
        if (badge) {
          badge.textContent = `${x.toFixed(1)}%, ${y.toFixed(1)}%`;
          badge.style.backgroundColor = '#2c6ecb'; // Highlight with different color
        }
        
        // Scroll element into view if needed
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    
    document.addEventListener('shopify:block:deselect', function(event) {
      const blockId = event.detail.blockId;
      const element = document.querySelector(`[data-shopify-id="${blockId}"]`);
      
      if (element) {
        element.classList.remove('shopify-selected');
        
        // Reset badge color
        const badge = element.querySelector('.editor-badge');
        if (badge) {
          badge.style.backgroundColor = '#5c6ac4';
        }
      }
    });
    
    // Listen for input changes to refresh elements immediately
    document.addEventListener('input', debounce(function(event) {
      // Check if the input is within a block settings form
      if (event.target.closest('.shopify-editor__card-fields')) {
        fixEditorContainer();
        setTimeout(initInteractiveElements, 300);
      }
    }, 300));
    
    // Add help button after a delay
    setTimeout(function() {
      const helpBtn = document.createElement('div');
      helpBtn.className = 'editor-help-btn';
      helpBtn.textContent = 'Interactive Points Help';
      helpBtn.addEventListener('click', function() {
        alert('Interactive Space Editor Guide:\n\n• The coordinate grid shows precise percentage positions\n• Use the cross-hair (✥) handle to drag and position points\n• Alt+Click anywhere to copy coordinates\n• Points are positioned using percentages (X%, Y%), ensuring consistent display on all devices\n• What you see in the editor will match the live site exactly');
      });
      document.body.appendChild(helpBtn);
    }, 1000);
  }
  
  // Debounce function to prevent too many refreshes
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }
});